/* eslint-disable n/no-unsupported-features/node-builtins -- this is a browser environment */
import axios from 'axios'
import { useRequestHeader } from '@dhl/axios'
import { getXsrfTokenFromCookie } from '@dhl/receiver-axios'
import { localStorageLocale } from './i18n'

export const instance = () =>
  axios.create({
    headers: {
      'X-XSRF-TOKEN': getXsrfTokenFromCookie(),
      'X-LANG': localStorage.getItem(localStorageLocale) || '',
      'X-VERSION': 'latest',
      'X-REQUESTED-WITH': 'account-app',
    },
  })

export function useSetupRequestInterceptor() {
  useRequestHeader('X-LANG', localStorage.getItem(localStorageLocale) || '')
  useRequestHeader('X-REQUESTED-WITH', 'account-app')
  useRequestHeader('X-VERSION', 'latest')
}
